import Hero from "../components/site/Hero";
import Services from "../components/site/Services";
import WarumWir from "../components/site/WarumWir";
import UberUns from "../components/site/UberUns";
import Team from "../components/site/Team";
import Faq from "../components/site/Faq";
import Kontakt from "../components/site/Kontakt";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <Services />
      <WarumWir />
      <UberUns />
      <Team />
      <Faq />
      <Kontakt />
    </main>
  );
}
